import React from "react";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import DevelopmentPerformance from "../components/DevelopmentPerformance/DevelopmentPerformance";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import { Helmet } from "react-helmet";
import {
  HireAngularBannerList,
  HireAngularFactsData,
  HireAngularFaqData,
  hireAngularPageContent,
  HireAngularServicesData,
  HireAngularSolutionsData,
  HireAngularSteps,
  mainBannerImg,
  tabItems,
  tabs,
  techCombinations,
} from "../data/hireAngularPagedata";
import HirePageExperties from "../components/hirepageExperties/HirePageExperties";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import HirePageEngagmentModels from "../components/hire-page-engagment-models/HirePageEngagmentModels";
import HirePageAppIdea from "../components/hire-page-app-idea/HirePageAppIdea";
import ContactSection from "../components/contactSection/ContactSection";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import SimpleModels from "../components/simpleEngagementModels";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";

const HireAngular = () => {
  const { t } = useTranslation("hireAngularPage");
  const BannerData = t("bannerData", { returnObjects: true });
  const ServicesSection = t("servicesData", { returnObjects: true });
  const performanceSection = t("solutionData", { returnObjects: true });
  const combinationSection = t("combinationData", { returnObjects: true });
  const stepsSection = t("pageStepsData", { returnObjects: true });
  const coverTheStackSection = t("coverTheStackData", { returnObjects: true });
  const factsData = t("factsData", { returnObjects: true });
  const appIdeaContent = t("appIdeaData", { returnObjects: true });
  const faqContent = t("faqData", { returnObjects: true });
  const engagementModelSection = t("hirePageEngagmentModelSection", {
    returnObjects: true,
  });
  const mainBannerImg = t("mainBannerImgData", { returnObjects: true });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("hireAngularTitle", { returnObjects: false });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta
          name="description"
          content="Hire top Angular developers for cutting-edge web apps. Custom Angular development services for fast, interactive user experiences."
        />
      </Helmet>

      <MegaMenu />

      <HirePageBanner
        diffBannerBackgroundImage={mainBannerImg?.backgroundImage}
        image={""}
        mainHeading={BannerData?.mainHeading}
        content={BannerData?.content}
        btnText={BannerData?.btnText}
        bannerList={BannerData?.HireAngularBannerList}
      />

      <OurServices
        mainHeading={ServicesSection?.mainHeading}
        description={ServicesSection?.sectionDescription}
        servicesCardsData={ServicesSection?.servicesData}
        buttonText="Schedule a Call Today"
      />

      <DevelopmentPerformance
        heading={performanceSection?.mainHeading}
        greenHeading={performanceSection?.greenHeading}
        subHeading={performanceSection?.sectionDescription}
        solutions={performanceSection?.solutions}
        buttonText={performanceSection?.buttonText}
      />

      <HireCombinationSection
        combinations={combinationSection?.combinations}
        heading={combinationSection?.mainHeading}
        description={combinationSection?.sectionDescription}
      />

      <HirePageSteps
        heading={stepsSection?.mainHeading}
        subHeading={stepsSection?.sectionDescription}
        steps={stepsSection?.angularSteps}
        buttonText={stepsSection?.buttonText}
      />

      <CoverTheStack
        whereStart={coverTheStackSection?.defaultOpenTab}
        mainHeading={coverTheStackSection?.mainHeading}
        subHeading={coverTheStackSection?.sectionDescription}
        tabs={coverTheStackSection?.tabs}
        tabItems={coverTheStackSection?.tabItems}
      />

      <HireExpertFacts
        heading={factsData?.mainHeading}
        greenHeading={factsData?.greenHeading}
        facts={factsData?.factData}
        diffBannerBackgroundImage={mainBannerImg?.factBackgroundImage}
        buttonText={factsData?.buttonText}
      />

      <HirePageAppIdea
        heading={appIdeaContent?.mainHeading}
        content={appIdeaContent?.sectionDescription}
      />

      {/* <HirePageEngagmentModels heading={engagementModelSection?.headingContent} content={engagementModelSection?.discription} hiringDetails={engagementModelSection?.hiringDetails} buttonText={engagementModelSection?.buttonText} /> */}

      <SimpleModels content={engagementModelsContent} />

      <TrendsInsights specificClass="mobile-dev-page" category="all" />

      <SecondFaq
        specificClass="mobile-dev-page"
        faqs={faqContent?.questionAnswer}
        mainHeading={faqContent?.mainHeading}
        subHeading={faqContent?.sectionDescription}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default HireAngular;
